import React, { useState, useEffect, useCallback } from "react";
import ImageZoom from "react-image-zoom-rotate";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Button,
} from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import { ArrowBack, ArrowForward, Flag } from "@material-ui/icons";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(grey[900]),
    backgroundColor: grey[900],
    "&:hover": {
      backgroundColor: grey[900],
    },
    height: 50,
    minWidth: 100,
  },
}))(Button);

function ViewResponses(props) {
  const { benchmarkId, imageKey: encodedImageKey } = useParams();
  const initialImageKey = decodeURIComponent(encodedImageKey);

  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [modelOutput, setModelOutput] = useState({});
  const [validationOutput, setValidationOutput] = useState({});
  const [type, setType] = useState("");
  const [ocr, setOcr] = useState([]);
  const [flag, setFlag] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const [currentImageKey, setCurrentImageKey] = useState(initialImageKey);
  const [benchmarkDetails, setBenchmarkDetails] = useState(props.location.state || {
    benchmark: benchmarkId,
    id: '',
    name: '',
    benchmarkType: '',
    ocrType: '',
    projectType: '',
    inferenceList: []
  });

  const loadData = (imgKey = currentImageKey) => {
    const imageId = imgKey.split('/').pop().split('.')[0];
    setLoading(true);
    axios
      .post("/api/benchmarks/responses/view", {
        benchmark: benchmarkId,
        imageId,
      })
      .then((res) => {
        setLoading(false);
        setImage(res.data.image);
        setModelOutput(res.data.modelOutput);
        setValidationOutput(res.data.validationOutput);
        setType(res.data.type);
        setOcr(res.data.ocr);
        if (res.data.flags && res.data.flags[imageId] && res.data.flags[imageId].response) {
          setFlag(res.data.flags[imageId].response);
        } else {
          setFlag(false);
        }
      })
      .catch((e) => {
        setLoading(false);
        enqueueSnackbar('Error', {
          variant: "error",
        });
      });
  };

  const getDetails = async () => {
    try {
      const res = await axios.post('/api/benchmarks/status', { benchmark: benchmarkId });
      const imagesRes = await axios.post("/api/benchmarks/images/list", { benchmarkId });
      const infList = [];
      imagesRes.data.images.forEach((obj) => {
        if (obj.inference) {
          infList.push(obj.imageKey);
        }
      });

      setBenchmarkDetails({
        benchmark: benchmarkId,
        id: res.data.id,
        name: res.data.name,
        benchmarkType: res.data.benchmarkType,
        ocrType: res.data.ocrType,
        projectType: res.data.projectType,
        inferenceList: infList
      });
    } catch (e) {
      console.error("Error fetching benchmark details", e);
    }
  };

  const handlePrevious = () => {
    const { inferenceList } = benchmarkDetails;
    if (!inferenceList || inferenceList.length === 0) return;
    const currentIndex = inferenceList.indexOf(currentImageKey);
    let nextIndex = currentIndex - 1;
    if (nextIndex < 0) {
      nextIndex = inferenceList.length - 1;
    }
    const nextKey = inferenceList[nextIndex];
    setCurrentImageKey(nextKey);
    props.history.replace(`/benchmark/viewResponse/${benchmarkId}/${encodeURIComponent(nextKey)}`);
  };

  const handleNext = () => {
    const { inferenceList } = benchmarkDetails;
    if (!inferenceList || inferenceList.length === 0) return;
    const currentIndex = inferenceList.indexOf(currentImageKey);
    let nextIndex = currentIndex + 1;
    if (nextIndex > inferenceList.length - 1) {
      nextIndex = 0;
    }
    const nextKey = inferenceList[nextIndex];
    setCurrentImageKey(nextKey);
    props.history.replace(`/benchmark/viewResponse/${benchmarkId}/${encodeURIComponent(nextKey)}`);
  };

  const handleFlag = () => {
    const imageId = currentImageKey.split('/').pop().split('.')[0];
    axios
      .post("/api/benchmarks/flags/flag", {
        benchmark: benchmarkId,
        imageId,
        value: !flag,
        type: 'response'
      })
      .then((res) => {
        loadData();
      })
      .catch((e) => {
        enqueueSnackbar(e.response.data, {
          variant: "error",
        });
      });
  };


  const handleKeyNavigation = useCallback((event) => {
    if (!loading) {
      if (event.keyCode === 37) {
        handlePrevious();
      }
      if (event.keyCode === 39) {
        handleNext();
      }
    }
  }, []);

  const handleHome = () => {
    props.history.push('/');
  };

  useEffect(() => {
    loadData();
    if (!benchmarkDetails.id) {
      getDetails();
    }
    document.addEventListener("keydown", handleKeyNavigation, false);
    return () => {
      document.removeEventListener("keydown", handleKeyNavigation, false);
    };
  }, [currentImageKey]);
  pieces:

  return (
    <div style={{ paddingLeft: 15, paddingRight: 15 }}>
      <ColorButton
        onClick={handleHome}
        variant="contained"
        color="primary"
        style={{ float: "right", marginRight: "90px" }}
      >
        Home
      </ColorButton>
      <br></br>
      <br></br>
      <h1>Image: {currentImageKey.split('/').pop()}</h1>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <ImageZoom
            rotate={(clockwise) => {
              return (
                <div>
                  <Button
                    onClick={clockwise}
                    style={{ position: "absolute", right: 0, zIndex: 1 }}
                  >
                    ↻
                  </Button>
                </div>
              );
            }}
            src={`data:image/png;base64,${image}`}
            width={650}
            zoomWidth={500}
          />
        </Grid>
        <Grid item xs={6}>
          {benchmarkDetails.benchmarkType === "group" ? (
            <TableContainer>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">Output</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell align="center">{type}</StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
          ) : (<>
            {benchmarkDetails.projectType !== 'validation' && <>
              <TableContainer>
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Labels</StyledTableCell>
                      <StyledTableCell align="center">
                        model_output
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        conf
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(modelOutput).length === 0
                      ? ""
                      : Object.keys(modelOutput).map((key) => (
                        <StyledTableRow key={key}>
                          <StyledTableCell component="th" scope="row">
                            {key}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {modelOutput[key].value}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {modelOutput[key].conf}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>}
            {benchmarkDetails.projectType !== 'extraction' && <>
              <br></br>
              <h1>Validation</h1>
              <TableContainer>
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Labels</StyledTableCell>
                      <StyledTableCell align="center">
                        validation
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(validationOutput).length === 0
                      ? ""
                      : Object.keys(validationOutput).map((key) => (
                        <StyledTableRow key={key}>
                          <StyledTableCell component="th" scope="row">
                            {key}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {validationOutput[key].value}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>}
          </>
          )}
          <br></br>
          <br></br>
          <Button
            onClick={handlePrevious}
            variant="contained"
            color="black"
            disabled={loading}
            startIcon={<ArrowBack />}
          >
            Previous
          </Button>{" "}
          <Button
            onClick={handleNext}
            variant="contained"
            color="black"
            disabled={loading}
            endIcon={<ArrowForward />}
          >
            Next
          </Button>{" "}
          <Button
            onClick={handleFlag}
            variant="contained"
            color="secondary"
            disabled={loading}
            endIcon={<Flag />}
          >
            {flag ? "Unflag" : "Flag"}
          </Button>
        </Grid>
      </Grid>
      <div style={{ paddingLeft: 30 }}>
        <h1 style={{ fontSize: 20 }}>OCR Output</h1>
        {ocr.map(function (line, i) {
          return (
            <p style={{ margin: 0 }}>
              {line}
              <br></br>
            </p>
          );
        })}
      </div>
      <br></br>
      <br></br>
    </div>
  );
}

export default ViewResponses;
